export const mockData = {
  features: [
    {
      icon: 'check',
      title: 'Quality over Quantity',
      description: 'All of our registered student tour guides are trained and approved by professional tour guides in their respective regions, ensuring high-quality and knowledgeable service.'
    },
    {
      icon: 'dollar',
      title: 'Affordable Price',
      description: 'Student tour guides offer more affordable options compared to the standard high prices on the market.'
    },
    {
      icon: 'smile',
      title: 'Personalized Accommodation',
      description: 'Hire a history major student who will tell you amazing stories behind the walls, or a Sport Management student who will show you Yankee Stadium and what sports business is all about.'
    }
  ],
  testimonials: [
    {
      name: 'Happy family from Missouri',
      text: 'Thanks guys, keep up the good work! You made my travel experience enjoyable. I\'ll definitely use again.',
      image: 'https://images.unsplash.com/photo-1497184380246-bde200db36c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxoYXBweSUyMHRyYXZlbGVyc3xlbnwwfHx8fDE3NjAyMTMwMzF8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      name: 'Sarah Thompson',
      text: 'Our guide was fantastic! As a history student, she brought every landmark to life with fascinating stories.',
      image: 'https://images.unsplash.com/photo-1539576776193-2c07122e5fee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxoYXBweSUyMHRyYXZlbGVyc3xlbnwwfHx8fDE3NjAyMTMwMzF8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      name: 'The Rodriguez Family',
      text: 'Best tour experience we\'ve had! Affordable, personal, and genuinely fun. Highly recommend!',
      image: 'https://images.pexels.com/photos/4881164/pexels-photo-4881164.jpeg'
    }
  ],
  tours: [
    {
      id: 1,
      name: 'Classic Manhattan Tour',
      description: 'Explore iconic landmarks including Times Square, Central Park, and the Empire State Building.',
      duration: '3 hours',
      price: 45,
      maxPeople: 15,
      location: 'Manhattan',
      image: 'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=600'
    },
    {
      id: 2,
      name: 'Brooklyn Bridge Walk',
      description: 'Walk across the historic Brooklyn Bridge and explore DUMBO neighborhood.',
      duration: '2.5 hours',
      price: 35,
      maxPeople: 20,
      location: 'Brooklyn',
      image: 'https://images.unsplash.com/photo-1513581166391-887a96ddeafd?w=600'
    },
    {
      id: 3,
      name: 'Wall Street & Financial District',
      description: 'Discover the heart of global finance, including the NYSE and Charging Bull.',
      duration: '2 hours',
      price: 40,
      maxPeople: 12,
      location: 'Lower Manhattan',
      image: 'https://images.unsplash.com/photo-1541336032412-2048cb6d5e53?w=600'
    },
    {
      id: 4,
      name: 'Greenwich Village Art Tour',
      description: 'Experience the artistic heart of NYC with galleries, street art, and bohemian culture.',
      duration: '3 hours',
      price: 50,
      maxPeople: 10,
      location: 'Greenwich Village',
      image: 'https://images.unsplash.com/photo-1518391846015-55a9cc003b25?w=600'
    },
    {
      id: 5,
      name: 'Central Park Discovery',
      description: 'Explore the green oasis of NYC including Bethesda Fountain and Bow Bridge.',
      duration: '2 hours',
      price: 30,
      maxPeople: 25,
      location: 'Central Park',
      image: 'https://images.unsplash.com/photo-1568515045052-f9a854d70bfd?w=600'
    },
    {
      id: 6,
      name: 'Food Tour of Chinatown',
      description: 'Taste authentic cuisine and learn about the rich cultural heritage of Chinatown.',
      duration: '3.5 hours',
      price: 65,
      maxPeople: 8,
      location: 'Chinatown',
      image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=600'
    }
  ],
  guides: [
    {
      id: 1,
      name: 'Emily Chen',
      title: 'History Major',
      school: 'Columbia University',
      major: 'American History',
      rating: '4.9',
      tours: 87,
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400'
    },
    {
      id: 2,
      name: 'Marcus Johnson',
      title: 'Sports Management',
      school: 'NYU',
      major: 'Sport Management',
      rating: '4.8',
      tours: 65,
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400'
    },
    {
      id: 3,
      name: 'Sofia Rodriguez',
      title: 'Art History',
      school: 'Parsons',
      major: 'Art History',
      rating: '5.0',
      tours: 92,
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400'
    },
    {
      id: 4,
      name: 'David Kim',
      title: 'Urban Studies',
      school: 'Columbia University',
      major: 'Urban Planning',
      rating: '4.9',
      tours: 78,
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400'
    },
    {
      id: 5,
      name: 'Aisha Patel',
      title: 'Architecture',
      school: 'Cooper Union',
      major: 'Architecture',
      rating: '4.8',
      tours: 54,
      image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400'
    },
    {
      id: 6,
      name: 'Jake Murphy',
      title: 'Business',
      school: 'NYU Stern',
      major: 'Finance',
      rating: '4.7',
      tours: 61,
      image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400'
    },
    {
      id: 7,
      name: 'Maya Williams',
      title: 'Culinary Arts',
      school: 'ICE',
      major: 'Culinary Arts',
      rating: '5.0',
      tours: 103,
      image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400'
    },
    {
      id: 8,
      name: 'Alex Zhang',
      title: 'Photography',
      school: 'SVA',
      major: 'Photography',
      rating: '4.9',
      tours: 72,
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400'
    }
  ],
  instructors: [
    {
      id: 'instructor-1',
      name: 'Sara Lyons',
      title: 'Licensed NYC Tour Guide & Theatre Artist',
      school: 'SUNY New Paltz | Drexel University',
      major: 'BA Theatre & History | MS Arts Administration',
      bio: 'Sara Lyons is a tour guide and theatre artist from Port Washington, NY. She finds joy in telling stories in new and exciting ways, which is why she loves guiding so much. She is also a playwright and theatre producer, and she looks forward to the continuing intersection between her crafts, as she writes and tours in multifaceted projects.',
      specialTours: [
        'Statue of Liberty/Ellis Island',
        'Grand Central Terminal',
        'SoHo/Little Italy/Chinatown',
        'Lower Manhattan',
        'Broadway Theatres',
        'Greenwich Village (General & LGBT+)',
        'Hudson Yards',
        'Full-Day Manhattan',
        'Central Park',
        'High Line/Chelsea/Meatpacking District',
        'SoHo Art & Design History',
        'In-depth Grand Central Tour',
        'Immigration in NYC',
        'How to Live in NYC',
        'Five-Borough Revolutionary NYC'
      ],
      rating: '4.9',
      tours: 87,
      image: 'https://customer-assets.emergentagent.com/job_travel-booking-36/artifacts/ujecwkin_image.png',
      availableSlots: [
        { date: 'November 21, 2025', time: '7:00 PM - 8:00 PM', available: true, spotsLeft: 8 },
        { date: 'November 25, 2025', time: '7:00 PM - 8:00 PM', available: true, spotsLeft: 6 },
        { date: 'December 1, 2025', time: '7:00 PM - 8:00 PM', available: true, spotsLeft: 9 },
        { date: 'December 9, 2025', time: '7:00 PM - 8:00 PM', available: true, spotsLeft: 7 },
        { date: 'December 16, 2025', time: '7:00 PM - 8:00 PM', available: true, spotsLeft: 10 },
        { date: 'December 29, 2025', time: '7:00 PM - 8:00 PM', available: true, spotsLeft: 5 },
        { date: 'December 30, 2025', time: '7:00 PM - 8:00 PM', available: true, spotsLeft: 8 },
        { date: 'January 5, 2026', time: '7:00 PM - 8:00 PM', available: true, spotsLeft: 6 }
      ]
    },
    {
      id: 'instructor-2',
      name: 'Ayinde Stevens',
      title: 'Licensed NYC Tour Guide & Cityscape Photographer',
      school: 'Native New Yorker',
      major: 'Transit & Cityscape Photography Specialist',
      bio: 'Native New Yorker and licensed tour guide with a passion for capturing the essence of NYC through photography. As a cityscape and transit photographer, Ayinde brings a unique visual perspective to his tours, showcasing the city through the lens of both history and modern urban culture. Member of @nycprimeshot with prints available via Darkroom.',
      specialties: [
        'Cityscape Photography Tours',
        'NYC Transit History',
        'Urban Photography Workshops',
        'Native NYC Insights',
        'iPhone & Nikon Photography'
      ],
      rating: '4.8',
      tours: 65,
      image: 'https://customer-assets.emergentagent.com/job_travel-booking-36/artifacts/45zgpbs6_image.png',
      availableSlots: [
        { date: 'October 29, 2025', time: '7:00 PM - 8:00 PM', available: true, spotsLeft: 8 }
      ]
    }
  ]
};